import { Link } from "react-router-dom";
import { Home, PhoneCall } from "lucide-react";
import SEO from "@/components/SEO";
import { CLINIC } from "@/data/content";

const NotFound = () => (
  <>
    <SEO
      title="Page Not Found | Delhi STD Clinic"
      description="The page you are looking for could not be found."
      path="/404"
    />
    <section className="min-h-[70vh] flex items-center justify-center bg-[#FAF9F6] pt-24" data-testid="not-found">
      <div className="text-center px-5">
        <p className="font-serif text-8xl font-light text-emerald-900/30">404</p>
        <h1 className="mt-4 font-serif text-3xl sm:text-4xl font-semibold text-slate-950">
          This page could not be found
        </h1>
        <p className="mt-4 text-slate-600 max-w-md mx-auto">
          The link may be outdated. You can return home or contact the clinic directly.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            data-testid="not-found-home"
            className="inline-flex items-center gap-2 bg-emerald-900 hover:bg-emerald-800 text-white font-semibold text-sm px-7 py-3.5 rounded-full transition-all"
          >
            <Home className="w-4 h-4" /> Back to Home
          </Link>
          <a
            href={`tel:${CLINIC.phoneRaw}`}
            data-testid="not-found-call"
            className="inline-flex items-center gap-2 text-emerald-950 font-semibold text-sm px-5 py-3.5 underline underline-offset-8 decoration-emerald-700/40"
          >
            <PhoneCall className="w-4 h-4" /> {CLINIC.phoneDisplay}
          </a>
        </div>
      </div>
    </section>
  </>
);

export default NotFound;
